import { Box, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router";

interface Props {
  title: string;
  onBack?: () => void;
  back?: string;
}

export default function AppBar({ title, onBack, back }: Props): ReactElement {
  const navigate = useNavigate();
  return (
    <>
      <Stack
        direction="row"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          background: "rgb(238, 246, 248)",
          py: 2,
          px: 2,
          zIndex: 9999,
        }}
      >
        <div>
          {onBack ? (
            <ArrowBackIosIcon fontSize="small" onClick={onBack} />
          ) : (
            <ArrowBackIosIcon fontSize="small" onClick={() => navigate(-1)} />
          )}
        </div>
        <Typography variant="h5">{title}</Typography>
        <div></div>
      </Stack>
      <Box sx={{ height: "64px", mt: "0 !important" }} />
    </>
  );
}
